import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { toSpanishDate } from '../../../helpers/dateFormat'
import { numberFormat } from '../../../helpers/numberFormat'

export const DivestmentLPTableSmall = ({ divest }) => {

    const { t } = useTranslation('global')
    const { participationValuation, divestmentParticipation, myPercentage, salesPrice, divestmentDate, investmentDate } = divest
    const shares = ((divestmentParticipation) * (myPercentage / 100)).toFixed(2)
    const capitalGain = (divestmentParticipation * salesPrice) - (participationValuation * divestmentParticipation)


    return (
        <>
            <Stack direction='row' flexWrap='wrap' justifyContent='space-evenly' width='100%' >
                <Stack width={{xs: '550px', sm: 'auto'}}>
                    <Stack direction='row' gap={2} justifyContent='space-between' alignItems='flex-end'>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('divestment.investmentDate')}: </Typography>
                        <Typography variant='caption' color='secondary'>{toSpanishDate(investmentDate)}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' gap={2} >
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('divestment.startup')}: </Typography>
                        <Typography variant='caption' color='secondary'>{divest.startupAlias}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between'  gap={2}>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('positions.roundNumber')}: </Typography>
                        <Typography variant='caption' color='secondary'>{divest.roundNumber}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' gap={2}>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('positions.amount')}: </Typography>
                        <Typography variant='caption' color='secondary'>{numberFormat(((participationValuation * divestmentParticipation) * (myPercentage / 100)).toFixed(2))}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' gap={2} alignItems='flex-end'>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('positions.participationValuation')}: </Typography>
                        <Typography variant='caption' color='secondary'>{(isNaN(participationValuation) || participationValuation === null || participationValuation === 'Infinity' ? '-' : numberFormat(participationValuation))}</Typography>
                    </Stack>
                </Stack>
                <Stack width={{xs: '550px', sm: 'auto'}} >
                    <Stack direction='row' justifyContent='space-between' gap={2}>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('divestment.realizedValue')}: </Typography>
                        <Typography variant='caption' color='secondary'>{isNaN(shares) || shares === null || shares === 'Infinity' ? '-' : numberFormat(shares)}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' gap={2} alignItems='flex-end'>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('divestment.salesPrice')}: </Typography>
                        <Typography variant='caption' color='secondary'>{salesPrice}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' gap={2}>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('positions.capitalGain')}: </Typography>
                        <Typography variant='caption' color='secondary'>{isNaN(capitalGain) ? '-' : numberFormat((capitalGain * (myPercentage / 100)).toFixed(2))}</Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' gap={2} alignItems='flex-end'>
                        <Typography variant='caption' color='primary' marginRight='10px'>{t('divestment.divestmentDate')}: </Typography>
                        <Typography variant='caption' color='secondary'>{toSpanishDate(divestmentDate)}</Typography>
                    </Stack>
                </Stack>
            </Stack>
        </>
    )
}
